import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

function LikeItem({ productIDdd, IsLikedIte }) {
  console.log({ productIDdd, IsLikedIte });

  const navigate = useNavigate();

  // Initialize state with the prop value
  const [checkLikeItem, setCheckLikeItem] = useState(IsLikedIte);

  // Use useEffect to update state when IsLikedIte changes
  useEffect(() => {
    setCheckLikeItem(IsLikedIte);
  }, [IsLikedIte]);
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const addToWishList = () => {
    if (!tokena) {
      localStorage.setItem("redirectAfterLogin", `/product/${productIDdd}`);
      navigate("/login");
      return;
    }

    setCheckLikeItem((prev) => !prev);

    console.log(checkLikeItem);
    const config = {
      url: process.env.REACT_APP_BASE_URL + `wishlist/addWishlist`,
      method: "post",
      data: {
        userId: userId, // userId
        productId: productIDdd,
      },
    };
    console.log(config.data);

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (!checkLikeItem) {
          if (response?.data?.status == true) {
            toast.success("Product added in Wishlist", {
              position: "bottom-right",
              autoClose: 4000,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
              transitions: "Zoom",
            });
          }
        } else {
          toast.success("Product Remove From Wishlist", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transitions: "Zoom",
          });
        }

        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            //   transitions: "Zoom",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  console.log(checkLikeItem);

  return (
    <div>
      <button
        onClick={addToWishList}
        className="wish-btn"
        style={{ border: "none", background: "none" }}
      >
        <svg
          width="25px"
          height="25px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z"
            stroke={checkLikeItem ? "" : "#000000"}
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill={checkLikeItem ? "#E50010" : ""}
          />
        </svg>
      </button>
    </div>
  );
}

export default LikeItem;
